<template>
  <div class="subsidy">
    <HeroBanner
        :background-image="bannerImage"
        title="보청기 지원금"
        sub-title="청력 손실로 일상 소통에 어려움이 있는 분들의 <br>
        경제적 부담을 줄이고자<br>
        국가에서 보청기 구입 비용을 지원하고 있습니다."
    />

    <div class="subsidy-content">
      <!-- 보청기 지원금이란? -->
      <section class="info-section">
        <h2 class="main-title">보청기 지원금이란?</h2>

        <div class="subsection">
          <h3 class="sub-title">지원 대상</h3>
          <ul class="info-list">
            <li>국민건강보험 가입자 또는 피부양자 중</li>
            <li>청각장애 등록을 한 경우</li>
            <li>양쪽 귀 각각 60dB 이상의 난청 진단을 받아야 함</li>
            <li>청각장애 등급 판정을 받은 등록 장애인</li>
          </ul>
        </div>

        <div class="subsection">
          <h3 class="sub-title">지원 금액</h3>
          <ul class="info-list">
            <li>최대 131만원 지원(1회, 5년 주기/  편측 기준)</li>
          </ul>

          <!-- 건강보험 가입자 테이블 -->
          <div class="table-group">
            <h4 class="table-title">1. 건강보험 가입자</h4>
            <div>(정부 지원금 90%, 본인 부담금 10%)</div>
            <div class="grade-table">
              <div class="table-container">
                <div class="table-row header-row">
                  <div class="table-value">지원 내용</div>
                  <div class="table-value">1인당<br>지원 금액</div>
                </div>
                <div class="table-row">
                  <div class="table-value">보청기 + 초기적합관리</div>
                  <div class="table-value">최대 999,000원</div>
                </div>
                <div class="table-row">
                  <div class="table-value">후기적합관리</div>
                  <div class="table-value">최대 180,000원<br>(구입 후 1년 후부터 연간 <br> 45,000원씩 4년간)</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 의료급여 수급권자 테이블 -->
          <div class="table-group">
            <h4 class="table-title">2. 의료급여 수급권자, 차본경 대상자</h4>
            <div>(정부 지원금 100%)</div>
            <div class="grade-table">
              <div class="table-container">

                <div class="table-row header-row">
                  <div class="table-value">지원 내용</div>
                  <div class="table-value">1인당<br>지원 금액</div>
                </div>
                <div class="table-row">
                  <div class="table-value">보청기 + 초기적합관리</div>
                  <div class="table-value">최대 1,110,000원</div>
                </div>
                <div class="table-row">
                  <div class="table-value">후기적합관리</div>
                  <div class="table-value">최대 200,000원<br>(구입 후 1년 후부터 연간 <br> 50,000원씩 4년간)</div>
                </div>
              </div>
            </div>
          </div>

          <ul class="info-list">
            <li>실제 지급액은 구입한 보청기의 금액과 보험 적용 범위에  따라 달라짐</li>
            <li>5년마다 재지급 가능 <br> (단, 분실·파손 등 특수 사유는 별도 확인 필요)</li>
          </ul>
        </div>

        <div class="subsection">
          <h3 class="sub-title">유의 사항</h3>
          <ul class="info-list">
            <li>지원금은 등록된 급여 기준 제품에 한해 지급</li>
            <li>비급여 보청기 구입 시 지원금 일부만 인정될 수 있음</li>
            <li>정찰제 가격 운영, 사후관리 서비스 포함 여부 반드시 확인 필요</li>
            <li>지원금 외에 지방자치단체 추가 지원금이 있는 경우도 있으므로 거주지 확인 필수</li>
          </ul>
        </div>
      </section>

      <!-- 청각장애 복지카드 신청 방법 -->
      <section class="process-section">
        <h2 class="main-title">청각장애 복지카드 신청 방법</h2>

        <div class="grade-table">
          <div class="table-container">
            <div class="table-row header-row">
              <div class="table-label step-label"></div>
              <div class="table-value place-value">[장소] 해야할 일</div>
              <div class="table-value docs-value">필요 서류</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">1</div>
              <div class="table-value place-value">[행정복지센터]<br>장애진단의뢰서 발급 신청</div>
              <div class="table-value docs-value">신분증, 장애진단의뢰서</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">2</div>
              <div class="table-value place-value">[이비인후과]<br>청력검사 및 진단</div>
              <div class="table-value docs-value">신분증, 진단의뢰서, 진단서, 검사결과, 진료기록지</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">3</div>
              <div class="table-value place-value">[행정복지센터]<br>서류 제출 및 심사</div>
              <div class="table-value docs-value">이비인후과 진단 서류 일체, 증명사진, 신분증</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">4</div>
              <div class="table-value place-value">[국민연금공단] 장애등급 심사 후청각장애 증명서 및 복지카드 발급</div>
              <div class="table-value docs-value">장애정도결정서, 보초기기 처방전, 결과지, 증명사진 2매</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 보청기 보조금 신청 방법 -->
      <section class="process-section">
        <h2 class="main-title">보청기 보조금 신청 방법<br>(청각장애 등록 후)</h2>

        <div class="grade-table">
          <div class="table-container">
            <div class="table-row header-row">
              <div class="table-label step-label"></div>
              <div class="table-value place-value">[장소] 해야할 일</div>
              <div class="table-value docs-value">필요 서류</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">1</div>
              <div class="table-value place-value">[이비인후과]<br>보조기기 처방전 발급</div>
              <div class="table-value docs-value">(순음검사 및 이음검사 후) 보조기기 처방전, 검사 결과지</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">2</div>
              <div class="table-value place-value">[행정복지센터]<br>적합통지서 신청</div>
              <div class="table-value docs-value">이비인후과 검사 결과지</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">3</div>
              <div class="table-value place-value">[다비치 히어링 보청기]<br>보청기 상담 및 구매</div>
              <div class="table-value docs-value">보조기기 급여비 지급 청구서, 구매표준 계약서, 세금계산서 또는 영수증</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">4</div>
              <div class="table-value place-value">[이비인후과]<br>검수 확인</div>
              <div class="table-value docs-value">(착용일로부터 31일 후) 음장검사 후 검수확인서, 검사 결과지 수령</div>
            </div>
            <div class="table-row">
              <div class="table-label step-label">5</div>
              <div class="table-value place-value">[행정복지센터]<br>급여비 청구</div>
              <div class="table-value docs-value">지원금 청구 필수 서류, 검수확인서, 검사 결과지 등</div>
            </div>
          </div>
        </div>
        <!-- 안내 배너 -->
        <div class="info-banner">
          <p>보청기 지원금 신청하는 방법, 어렵지 않아요.<br>다비치 히어링 보청기에서 도와드리겠습니다.</p>
        </div>
      </section>



      <!-- 보청기 연말 정산 안내 -->
      <section class="tax-section">
        <h2 class="main-title">보청기 연말 정산 안내</h2>
        <p class="description">
          다비치 히어링 보청기는 국세청 인증 의료기기로 연말정산 시 의료비 세액공제 대상에 포함됩니다.
        </p>

        <div class="tax-subsection">
          <h3 class="sub-title">1. 의료비 세액 공제</h3>
          <ul class="info-list">
            <li>「의료기기법」 제2조에 따른 '의료기기'로 등록된 보청기</li>
            <li>장애인용 보청기 포함</li>
            <li>구입한 해당 연도(1월 1일~12월 31일) 지출된 의료비 해당</li>
          </ul>
        </div>

        <div class="tax-subsection">
          <h3 class="sub-title">2. 대상자</h3>
          <ul class="info-list">
            <li>본인/ 배우자/ 직계존속(부모, 조부모)/직계비속(자녀, 손자녀)/ 형제자매(기본공제 대상자 한정)</li>
          </ul>
        </div>

        <div class="tax-subsection">
          <h3 class="sub-title">3. 공제 금액</h3>
          <ul class="info-list">
            <li><span class="emphasis">세액공제율:</span> 15%</li>
            <li><span class="emphasis">공제 한도:</span> 소득금액의 30% 초과분부터 공제</li>
            <li><span class="emphasis">예시:</span> 연 소득 4,000만원일 경우, 의료비 총액이 120만원(4,000만x3%)을 초과해야 초과금액의 15% 공제</li>
          </ul>
        </div>

        <div class="tax-subsection">
          <h3 class="sub-title">4. 공제받기 위한 조건</h3>
          <ul class="info-list">
            <li><span class="emphasis">구입 장소:</span> 의료기기 판매업 허가를 받은 기관(다비치 히어링 보청기)</li>
            <li><span class="emphasis">영수증 형태:</span> 신용카드 결제 시 "의료비(보청기)"로 전자영수증 처리 또는 현금영수증 의료비용 선택</li>
            <li><span class="emphasis">증빙 서류:</span> 구입 영수증, 의료기기 판매업 신고번호 포함 명세서, 필요 시 의사 처방전(장애인 보청기용일 경우), 주민등록상 가족 관계 증빙(가족 공제 시)</li>
          </ul>
        </div>

        <div class="tax-subsection">
          <h2 class="main-title">연말 정산 신청 프로세스</h2>
          <ul class="info-list">
            <li><span class="emphasis">영수증 · 증명자료 확보</span><br> 보청기 구입 시 판매업체로부터(다비치 히어링 보청기) '의료비 세액공제용 영수증' 발급</li>
            <li><span class="emphasis">회사 또는 본인 신고 제출</span><br> 회사에 영수증 제출하여 세액공제 신청하거나 부양가족을 위해 지출한 경우 기본공제대상자로 등록이 되어 있다면 자녀 또는 배우자가 대신 신청 가능</li>
            <li><span class="emphasis">홈택스 등록 및 확인</span><br> 국세청 홈택스(온라인 서비스)를 통하 의료비 세액공제 자료 확인 및 직접 등록</li>
          </ul>
        </div>
      </section>

      <!-- 자주하는 질문 -->
      <section class="faq-section">
        <h2 class="main-title">자주하는 질문</h2>
        <ul class="info-list">
          <li>
            <span class="emphasis">부모님 보청기를 자녀가 결제했어요. 자녀가 공제받을 수 있나요?</span>
            <br>네, 가능합니다.<br>
            부모님이 자녀의 가본공제 대상자(소득 100만원 이하, 만 60세 이상)이면 자녀 명의의 카드로 결제한 금액은 자녀 의료비 세액공제로 인정됩니다.</li>
          <li><span class="emphasis">부모님이 직접 결제했는데, 자녀가 공제받을 수 있나요? </span>
            <br>네, 가능합니다.<br>
            부모님이 자녀의 기본공제 대상자라면, 결제자가 누구인지와 관계없이 자녀 명의로 의료비 공제 신청이 가능합니다.</li>
          <li><span class="emphasis">부모님이 소득이 많아서 기본공제 대상자가 아닌데 자녀가 공제받을 수 있나요?</span>
            <br> 불가능합니다.<br>
            이 경우에는 자녀가 공제받을 수 없고, 부모님이 직접 본인 명의로 의료비 세액공제를 신청하셔야 합니다.</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/03-top-img.png';

export default {
  name: 'Subsidy',
  components: {HeroBanner},
  data() {
    return {
      bannerImage: [bannerBg],
    };
  }
};
</script>

<style scoped lang="scss">
.emphasis{
  font-weight: 700;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 30px;
  letter-spacing: -2%;
  vertical-align: middle;
}
.subsidy {
  .subsidy-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: 56px 0 80px;
    background: #FFFFFF;
    gap: 30px;

    section {
      width: 100%;
      //max-width: 425px;
      padding: 0 36px;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
    h2.main-title{
      font-size: 26px;
    }

    .main-title {
      font-family: 'Noto Sans KR', sans-serif;
      font-weight: 700;
      font-size: 33px;
      line-height: 45px;
      letter-spacing: -1px;
      color: #222222;
      margin: 0;
    }

    .sub-title {
      font-family: 'Noto Sans KR', sans-serif;
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -0.74px;
      color: #222222;
      margin: 0;
    }



    .description {
      font-family: 'Noto Sans KR', sans-serif;
      font-weight: 350;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: -0.54px;
      color: #222222;
      margin: 0;
    }

    .info-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 350;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.54px;
        color: #222222;
        padding-left: 16px;
        position: relative;

        &:before {
          content: '•';
          position: absolute;
          left: 0;
        }
      }
    }

    .subsection {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .table-group {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-top: 20px;
    }

    .table-title {
      font-family: 'Noto Sans KR', sans-serif;
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: -0.54px;
      color: #222222;
      margin: 0;
    }

    .grade-table {
      width: 100%;
      //max-width: 425px;
      //padding: 0 36px;
      display: flex;
      flex-direction: column;
      gap: 24px;

      .table-container {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #222222;
        border-bottom: 1px solid #222222;

        .table-row {
          display: flex;
          border-bottom: 1px solid #DDDDDD;

          &:last-child {
            border-bottom: none;
          }

          &.header-row {
            background: #F9F9F9;

            .table-label,
            .table-value {
              font-weight: 700;
              background: #F9F9F9;
            }
          }

          .table-label {
            width: 111px;
            min-width: 111px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 22px 0;
            background: #F9F9F9;
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 700;
            font-size: 18px;
            line-height: 32px;
            letter-spacing: -0.54px;
            color: #222222;
            text-align: center;
            border-right: 1px solid #DDDDDD;

            &.step-label {
              width: 49px;
              min-width: 49px;
            }
          }

          .table-value {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 22px;
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 350;
            font-size: 18px;
            line-height: 33px;
            letter-spacing: -0.54px;
            color: #222222;
            text-align: center;
            border-right: 1px solid #DDDDDD;

            &:last-child {
              border-right: none;
            }

            &.place-value {
              width: 230px;
              min-width: 230px;
            }

            &.docs-value {
              width: 146px;
              font-size: 16px;
              line-height: 26px;
              border-right: none;
            }
          }
        }
      }
    }

    .info-banner {
      width: 100%;
      //max-width: 425px;
      //margin: 0 36px;
      background: #153F8F;
      padding: 26px 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 700;
        font-size: 20px;
        line-height: 36px;
        letter-spacing: -0.05em;
        color: #F9F9F9;
        text-align: center;
        margin: 0;
      }
    }

    .tax-section{
      margin-top: 30px;
    }
    .tax-section,
    .faq-section {
      .subsection,
      .tax-subsection {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    }
  }

  @media (max-width: 768px) {
    section {
      padding: 0 20px !important;
    }
    .subsidy-content {
      //padding: 40px 16px 60px;
      gap: 24px;

      .main-title {
        font-size: 28px;
        line-height: 38px;
      }

      .sub-title,
      .table-title {
        font-size: 22px;
        line-height: 30px;
      }

      .description,
      .info-list li {
        font-size: 16px;
        line-height: 28px;
      }

      .grade-table {
        .table-container {
          .table-row {
            .table-label {
              width: 90px;
              min-width: 90px;
              padding: 18px 0;
              font-size: 16px;
              line-height: 28px;

              &.step-label {
                width: 40px;
                min-width: 40px;
              }
            }

            .table-value {
              padding: 18px;
              font-size: 16px;
              line-height: 28px;

              &.place-value {
                width: 180px;
                min-width: 180px;
              }

              &.docs-value {
                width: 120px;
                font-size: 14px;
                line-height: 24px;
              }
            }
          }
        }
      }

      .info-banner p {
        font-size: 18px;
        line-height: 32px;
      }
    }
  }

  @media (max-width: 450px) {

    .subsidy-content {
      padding: 30px 0 50px;
      gap: 20px;

      .main-title {
        font-size: 24px;
        line-height: 34px;
      }

      .sub-title,
      .table-title {
        font-size: 20px;
        line-height: 28px;
      }


      .description,
      .info-list li {
        font-size: 15px;
        line-height: 26px;
      }

      .grade-table {
        .table-container {
          .table-row {
            .table-label {
              width: 80px;
              min-width: 80px;
              padding: 16px 0;
              font-size: 15px;
              line-height: 26px;

              &.step-label {
                width: 35px;
                min-width: 35px;
              }
            }

            .table-value {
              padding: 16px;
              font-size: 15px;
              line-height: 26px;

              &.place-value {
                width: 160px;
                min-width: 160px;
              }

              &.docs-value {
                width: 100px;
                font-size: 13px;
                line-height: 22px;
              }
            }
          }
        }
      }

      .info-banner {
        //padding: 20px 10px;

        p {
          font-size: 16px;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
